import React, { useRef } from 'react';
import CodeHighlight from './../../components/code-highlight/code-highlight.jsx';
import useTemplateInteractions from './../../composables/templateInteractions.js';

function UIModalNotification() {
	const rootRef = useRef(null);
	useTemplateInteractions(rootRef);

	return (
		<div ref={rootRef}>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<ul className="breadcrumb">
									<li className="breadcrumb-item">
										<a href="#/">{'UI Elements'}</a>
									</li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header">
									{' Modal & Notification '}
									<small>{'page header description goes here...'}</small>
								</h1>
								<hr />
								<div id="modal" className="mb-5">
									<h4>{'Modal'}</h4>
									<p>
										{
											'Use Bootstrap’s JavaScript modal plugin to add dialogs to your site for lightboxes, user notifications, or completely custom content. Please read the '
										}
										<a href="https://getbootstrap.com/docs/5.3/components/modal/" target="_blank" rel="noreferrer">
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="modal position-static d-block">
												<div className="modal-dialog">
													<div className="modal-content shadow-lg">
														<div className="modal-header">
															<h5 className="modal-title">{'Modal Title'}</h5>
															<button
																type="button"
																className="btn-close"
																data-bs-dismiss="modal"
															></button>
														</div>
														<div className="modal-body">
															<p>{'Modal body text goes here.'}</p>
														</div>
														<div className="modal-footer">
															<button
																type="button"
																className="btn btn-default"
																data-bs-dismiss="modal"
															>
																{'Close'}
															</button>
															<button type="button" className="btn btn-primary">
																{'Save changes'}
															</button>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-modal-notification/code-1.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="modalSizes" className="mb-5">
									<h4>{'Modal Sizes'}</h4>
									<p>
										{
											'Modals have three optional sizes, available via modifier classes to be placed on a '
										}
										<code>{'.modal-dialog'}</code>
										{
											'. These sizes kick in at certain breakpoints to avoid horizontal scrollbars on narrower viewports.'
										}
									</p>
									<div className="card">
										<div className="card-body">
											<button
												type="button"
												className="btn btn-primary me-2"
												data-bs-toggle="modal"
												data-bs-target="#modalXl"
											>
												{'Extra large modal'}
											</button>
											<button
												type="button"
												className="btn btn-primary me-2"
												data-bs-toggle="modal"
												data-bs-target="#modalLg"
											>
												{'Large modal'}
											</button>
											<button
												type="button"
												className="btn btn-primary me-2"
												data-bs-toggle="modal"
												data-bs-target="#modalSm"
											>
												{'Small modal'}
											</button>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-modal-notification/code-2.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="modalCover" className="mb-5">
									<h4>{'Modal Cover'}</h4>
									<p>
										{
											'Modal cover is an extended feature from Bootstrap modal. It provide the same background color as the modal content. Place a '
										}
										<code>{'.modal-cover'}</code>
										{' css class on '}
										<code>{'.modal'}</code>
										{' for full cover modal.'}
									</p>
									<div className="card">
										<div className="card-body">
											<button
												type="button"
												className="btn btn-primary me-2"
												data-bs-toggle="modal"
												data-bs-target="#modalCoverExample"
											>
												{'Modal Cover'}
											</button>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-modal-notification/code-3.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="toastsNotification" className="mb-5">
									<h4>{'Toasts Notification'}</h4>
									<p>
										{
											'Push notifications to your visitors with a toast, a lightweight and easily customizable alert message. Please read the '
										}
										<a href="https://getbootstrap.com/docs/5.3/components/toasts/" target="_blank" rel="noreferrer">
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options.'}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="toast show">
												<div className="toast-header">
													<i className="far fa-bell text-muted me-2"></i>
													<strong className="me-auto">{'Bootstrap'}</strong>
													<small>{'11 mins ago'}</small>
													<button
														type="button"
														className="btn-close"
														data-bs-dismiss="toast"
													></button>
												</div>
												<div className="toast-body">
													{' Hello, world! This is a toast message. '}
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-modal-notification/code-4.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="toastsContainer" className="mb-5">
									<h4>{'Toasts Container'}</h4>
									<p>
										{
											'Toasts container is an extended ui from Bootstrap toasts. Wrap the toasts with '
										}
										<code>{'.toasts-container'}</code>
										{' will allow toast to float within the right top position.'}
									</p>
									<div className="card">
										<div className="card-body">
											<a
												href="#/"
												className="btn btn-primary me-2"
												data-toggle="toast"
												data-target="#toast-1"
											>
												{'Show toast 1'}
											</a>
											<a
												href="#/"
												className="btn btn-primary"
												data-toggle="toast"
												data-target="#toast-2"
											>
												{'Show toast 2'}
											</a>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-modal-notification/code-5.json"
												/>
											</pre>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3">
								<nav
									id="sidebar-bootstrap"
									className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100"
								>
									<nav className="nav">
										<a className="nav-link active" href="#modal" data-toggle="scroll-to">
											{'Modal'}
										</a>
										<a className="nav-link" href="#modalSizes" data-toggle="scroll-to">
											{'Modal Sizes'}
										</a>
										<a className="nav-link" href="#modalCover" data-toggle="scroll-to">
											{'Modal Cover'}
										</a>
										<a className="nav-link" href="#toastsNotification" data-toggle="scroll-to">
											{'Toasts Notification'}
										</a>
										<a className="nav-link" href="#toastsContainer" data-toggle="scroll-to">
											{'Toasts Container'}
										</a>
									</nav>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="modal modal-cover fade" id="modalCoverExample">
				<div className="modal-dialog">
					<div className="modal-content container-sm mx-auto">
						<div className="modal-header pb-0">
							<h3 className="modal-title fs-1 fw-bold">{'Sign Up!'}</h3>
							<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
						</div>
						<div className="modal-body">
							<p className="mb-3">
								{' 25% Off On Your First Purchase* Enter code WELCOME at checkout'}
								<span className="d-none d-lg-inline">
									<br />
								</span>
								{' Discover new apps, things to do & more great news added daily! '}
							</p>
							<div className="row mb-5 gy-3">
								<div className="col-md-9">
									<div className="position-relative">
										<iconify-icon
											icon="ic:baseline-email"
											className="w-55px fs-4 text-muted position-absolute start-0 top-0 bottom-0 d-flex align-items-center justify-content-center"
										></iconify-icon>
										<input
											type="text"
											placeholder="Your email address here"
											className="form-control form-control-lg h-50px ps-5"
											name="icon-filter"
										/>
									</div>
								</div>
								<div className="col-md-3">
									<button type="button" className="btn btn-primary btn-lg btn-block h-50px w-100">
										{'Continue'}
									</button>
								</div>
							</div>
							<div className="mb-5">
								<a href="#/" className="text-muted">
									{'What is it? Terms and conditions'}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="modal fade" id="modalXl">
				<div className="modal-dialog modal-xl">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">{'Extra Large Modal'}</h5>
							<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
						</div>
						<div className="modal-body">{' ... '}</div>
					</div>
				</div>
			</div>
			<div className="modal fade" id="modalLg">
				<div className="modal-dialog modal-lg">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">{'Large Modal'}</h5>
							<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
						</div>
						<div className="modal-body">{' ... '}</div>
					</div>
				</div>
			</div>
			<div className="modal fade" id="modalSm">
				<div className="modal-dialog modal-sm">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">{'Small Modal'}</h5>
							<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
						</div>
						<div className="modal-body">{' ... '}</div>
					</div>
				</div>
			</div>
			<div className="toasts-container">
				<div className="toast fade hide mb-3" data-autohide="false" id="toast-1">
					<div className="toast-header">
						<i className="far fa-bell text-muted me-2"></i>
						<strong className="me-auto">{'Bootstrap'}</strong>
						<small>{'11 mins ago'}</small>
						<button type="button" className="btn-close" data-bs-dismiss="toast"></button>
					</div>
					<div className="toast-body">{' Hello, world! This is a toast message. '}</div>
				</div>
				<div className="toast fade hide mb-3" data-autohide="false" id="toast-2">
					<div className="toast-header">
						<i className="far fa-bell text-muted me-2"></i>
						<strong className="me-auto">{'Bootstrap'}</strong>
						<small>{'2 seconds ago'}</small>
						<button type="button" className="btn-close" data-bs-dismiss="toast"></button>
					</div>
					<div className="toast-body">{' See? Just like this. '}</div>
				</div>
			</div>
		</div>
	);
}

export default UIModalNotification;
